import React from 'react';
import classNames from 'classnames';
import styles from './form-field.module.scss';

export interface FormFieldProps {
  label?: React.ReactNode;
  hint?: React.ReactNode;
  error?: React.ReactNode;
  required?: boolean;
  showNecessity?: boolean;
  className?: string;
  children?: React.ReactNode;
}

export const FormField: React.FC<FormFieldProps> = ({
  label,
  hint,
  error,
  required = false,
  showNecessity = true,
  className,
  children
}) => {
  return (
    <div className={classNames('field', styles.formField, className, {
      [styles.isRequired]: showNecessity && required,
      [styles.isOptional]: showNecessity && !required
    })}>
      {label && <label className={styles.label}>{label}</label>}
      {children}
      {hint && !error && <div className={classNames('help', styles.hint)}>{hint}</div>}
      {error && <div className={classNames('help is-danger', styles.error)}>{error}</div>}
    </div>
  );
};
